import React from 'react';

import Popup from '../../Popup/Popup';
import {
    modalMobileStyle,
    modalStyle,
    renderModalCloseButton,
    renderModalContent
} from '../../../utils/content-util';
import { isMobileWidth } from '../../../theme/layoutUtilities';
import methodologyLanguage from '../methodology.json';
import styles from '../SFMethodology.css';

const MethodologyModal = (props) => {
    const { open, onClose } = props;
    const { contentId, modalTitle, mainDesc, content } = methodologyLanguage;

    return (
        <React.Fragment>
            <Popup
                open={open}
                onClose={onClose}
                closeOnEscape
                contentStyle={isMobileWidth() ? modalMobileStyle : modalStyle}
                overlayStyle={{ zIndex: '10000', overflow: 'auto' }}
            >
                <div className="methodology-modal-wrapper">
                    {renderModalCloseButton(onClose, styles)}
                    <h1 className="modal-title">{modalTitle}</h1>
                    <div className="modal-content">
                        <p>{mainDesc}</p>
                        {renderModalContent(contentId, content, styles)}
                    </div>
                </div>

                <style jsx>{styles}</style>
            </Popup>
        </React.Fragment>
    );
};

export default MethodologyModal;
